var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Tree',{attrs:{"data":_vm.permissionList,"show-checkbox":"","mutiple":""},on:{"on-check-change":_vm.checkChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }